// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_wrapper__ryjZf {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
}

.overlay_wrapper__ryjZf > svg {
  position: absolute;
  fill: var(--overlayForeground);
  animation: overlay_fadeIn__zY8A9 0.5s both;
}

@media (prefers-reduced-motion) {
  .overlay_wrapper__ryjZf > svg {
    animation-duration: 0s;
  }
}

@keyframes overlay_fadeIn__zY8A9 {
  from {
    transform: scale(0.5);
    opacity: 1;
  }

  to {
    transform: scale(1);
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/overlay/overlay.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;;EAEP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,0CAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".wrapper {\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  height: 100%;\n}\n\n.wrapper > svg {\n  position: absolute;\n  fill: var(--overlayForeground);\n  animation: fadeIn 0.5s both;\n}\n\n@media (prefers-reduced-motion) {\n  .wrapper > svg {\n    animation-duration: 0s;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    transform: scale(0.5);\n    opacity: 1;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `overlay_wrapper__ryjZf`,
	"fadeIn": `overlay_fadeIn__zY8A9`
};
module.exports = ___CSS_LOADER_EXPORT___;
